export const visitorsKeys = {
  all: ['visitors'],
  lists: () => [...visitorsKeys.all, 'list'],
  list: (page: number, perPage: number) => [...visitorsKeys.lists(), { page, perPage }],
} as const;
